import {fetchBaseQuery} from '@reduxjs/toolkit/query';
import {Mutex} from 'async-mutex';

import {logout, setAccessToken} from '../../reducers/authSlice';

import LocalStorageManager from "../../../Utils/localstorage";

const baseUrl = `${import.meta.env.VITE_BASE_URL}`;
const mutex = new Mutex();

const baseQuery = fetchBaseQuery({
    baseUrl,
    credentials: 'include'
});

const customFetchBase = async (args, api, extraOptions) => {
    await mutex.waitForUnlock();
    const {token = '', refreshToken = ''} = api.getState().auth.tokens || {};

    let result = await baseQuery(
        {...args, headers: {Authorization: `Bearer ${token}`}},
        api,
        extraOptions
    );

    const shouldSkipRetry = ((['/', '/login', '/register'].includes(window.location.pathname) ||
                window.location.pathname.includes('/charge') ||
                window.location.pathname.includes('/session'))) ||
        !(
            result.error?.status === 401 &&
            (!['/login', '/register'].includes(args.url) ||
                !args.url.includes('/users/charging-user-access'))
        );

    if (!shouldSkipRetry) {
        if (!mutex.isLocked()) {
            const release = await mutex.acquire();
            try {
                const refreshResult = await baseQuery(
                    {
                        credentials: 'include',
                        url: '/refresh-token',
                        method: 'POST',
                        body: {refreshToken}
                    },
                    api,
                    extraOptions
                );
                const newToken = refreshResult.data;
                if (newToken) {
                    LocalStorageManager.set('evChAccessToken', newToken)
                    api.dispatch(setAccessToken(newToken));
                    result = await baseQuery(
                        {...args, headers: {Authorization: `Bearer ${newToken.access.token}`}},
                        api,
                        extraOptions
                    );
                } else {
                    if(!LocalStorageManager.get('evChAccessToken')){
                        api.dispatch(logout());
                    }

                    window.location.href = '/login';
                }
            } finally {
                release();
            }
        } else {
            await mutex.waitForUnlock();
            result = await baseQuery(
                {...args, headers: {Authorization: `Bearer ${token}`}},
                api,
                extraOptions
            );
        }
    }

    return result;
};

export default customFetchBase;
